// EG-55 — filtros da Visão geral por empresa (exercício + certificado).
//
// A Visão geral renderiza um bloco por certificado com pilar. Fragmentar cada
// pilar em temas fez cada bloco crescer, então uma empresa com vários
// certificados vira rolagem infinita. Estes filtros recortam a página.
//
// Nada aqui vai ao backend: getCertificateByGroup já devolve c.exercise no
// payload de certificate/score. O filtro por exercício até existe no service
// (getCertificateByGroup aceita `exercise`), mas esta rota não o usa — e não
// precisa: o recorte é de leitura, sobre dado que já chegou.

export const TODOS = 'todos';

const escolhido = (valor) => valor !== undefined && valor !== null && valor !== TODOS;

/** Exercícios distintos, do mais recente para o mais antigo. */
export function exerciciosDe(certificados) {
  const anos = (certificados ?? [])
    .map((c) => c.exercise)
    .filter((ano) => ano !== null && ano !== undefined && ano !== '')
    .map(Number);

  return [...new Set(anos)].sort((a, b) => b - a);
}

/**
 * Há certificado sem exercício cadastrado?
 *
 * Importa porque exercício ausente NÃO vira opção no select — ausência não é um
 * valor a filtrar. Quem cobre esses certificados é o "Todos", e é por isso que
 * ele não pode ser um atalho para "o exercício mais recente".
 */
export function temSemExercicio(certificados) {
  return (certificados ?? []).some(
    (c) => c.exercise === null || c.exercise === undefined || c.exercise === ''
  );
}

/**
 * Os certificados que o dashboard sabe desenhar.
 *
 * Certificado de "só nota" (sem pilar) não tem os dois gráficos — o backend nem
 * monta `pillars` para ele. Oferecê-lo no select levaria o usuário a escolher
 * algo e não ver nada, sem explicação.
 */
export function exibiveis(certificados) {
  return (certificados ?? []).filter((c) => (c.pillars?.length ?? 0) > 0);
}

/**
 * Aplica o recorte. Preserva a ordem original — ela vem do backend
 * (ORDER BY c.created_at DESC) e não é deste módulo para reordenar.
 *
 * O <select> entrega string e o payload traz número, então a comparação
 * normaliza os dois lados: sem isso, qualquer ano escolhido devolveria vazio.
 */
export function filtrar(certificados, { exercicio, certificado } = {}) {
  let lista = certificados ?? [];

  if (escolhido(exercicio)) {
    lista = lista.filter((c) => Number(c.exercise) === Number(exercicio));
  }

  if (escolhido(certificado)) {
    lista = lista.filter(
      (c) => Number(c.id_certificate) === Number(certificado)
    );
  }

  return lista;
}
